import React, { useMemo } from 'react'
import { Box, Field, Flex, Select } from '@workwhile/ui'
import { useUserProfileById } from 'queries/user'
import { useUserPermissionsContextValue } from '../context/UserPermissionsProvider'
import { UserPicker } from './UserPicker'

export const UserPermissionsFilters = () => {
  const {
    state: { userId, permission, manageablePermissionOptions },
    actions: { setUserId, setPermission },
  } = useUserPermissionsContextValue()

  const permissionFilterOptions = useMemo(
    () =>
      manageablePermissionOptions.map((option) => ({
        label: option.name,
        value: option.value,
      })),
    [manageablePermissionOptions]
  )

  const { data: selectedProfile } = useUserProfileById(userId)
  const selectedUser =
    userId == null
      ? null
      : {
          userId,
          name: selectedProfile?.name ?? `User ${userId}`,
          email: selectedProfile?.email ?? '',
        }

  return (
    <Flex
      gap={3}
      mb={3}
      flexDirection={['column', 'column', 'row']}
      alignItems={['stretch', 'stretch', 'flex-end']}
      maxWidth={['100%', '100%', '100%', '70%']}
    >
      <Box flex={1} minWidth={0}>
        <UserPicker
          value={userId}
          selectedUser={selectedUser}
          onChange={(user) => setUserId(user?.userId ?? null)}
        />
      </Box>
      <Box flex={1} minWidth={0}>
        <Field label="Permission">
          <Select
            block
            isClearable
            placeholder="All permissions"
            options={permissionFilterOptions}
            value={
              permissionFilterOptions.find(
                (option) => option.value === permission
              ) ?? null
            }
            onChange={(option) => {
              setPermission(option?.value ?? null)
            }}
            aria-label="Filter by permission"
          />
        </Field>
      </Box>
    </Flex>
  )
}
